import {useTranslation} from 'react-i18next'
import {Config} from '../../constants/Config'
import {FontOptionType} from '../../models/editor/fontFamily'
import {ImgCaption} from '../../models/editor/imgCaption'
import StyleSheet from '../../utils/helpers/styleSheet'

const styles: StyleSheet = {
  selectable: {
    width: 100,
    backgroundColor: '#eaf1ea',
    paddingTop: 4,
    paddingBottom: 2,
    textAlign: 'center',
    cursor: 'pointer',
    marginRight: 10,
    fontFamily: 'Calibri',
    color: '#7ac943',
    borderRadius: 5,
    fontSize: '1.2em',
  },
  disabledSelectable: {
    cursor: 'default',
    backgroundColor: '#EEEEEE',
    color: '#AAAAAA',
  },
  selectedSelectable: {
    backgroundColor: '#45b000',
    color: 'white',
  },
}

interface FontOptionProps {
  img: ImgCaption
  onClick: () => void
  text: string
  fontOption: FontOptionType
}

export default function FontOption({
  img,
  onClick,
  text,
  fontOption,
}: FontOptionProps) {
  const {t} = useTranslation()
  const disabled = !Config.availableFontOptions[img.fontFamily][fontOption]

  return (
    <span
      title={disabled ? t('Nem érhető el') : undefined}
      style={
        !disabled
          ? img[fontOption]
            ? {...styles.selectable, ...styles.selectedSelectable}
            : styles.selectable
          : {...styles.selectable, ...styles.disabledSelectable}
      }
      className="selectable"
      onClick={() => {
        if (!disabled) {
          onClick()
        }
      }}>
      {text}
    </span>
  )
}
